import $axios from 'axios'
import { getToken } from '@/utils/auth'

// 导入文件
export function uploadFile(api, formData, callback) {
  const config = {
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: getToken()
    }
  }
  $axios.post(api, formData, config).then(response => {
    console.log(response)
    callback && callback(response.data)
  })
}

// 导出接口
export function downloadFile(api, params, fileName, callback) {
  const service = $axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
      Authorization: getToken(),
      'Content-type': 'application/json'
    },
    responseType: 'blob'
  })
  // 开始请求
  service({
    url: api,
    method: 'post',
    data: params
  }).then(res => {
    callback && callback(res)
    const content = res.data
    // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
    const blob = new Blob([content])
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName || '文件')
    } else {
      // URL.createObjectURL(object)表示生成一个File对象或Blob对象
      const url = window.URL.createObjectURL(blob)
      // 设置一个隐藏的a标签，href为输出流，设置download
      const dom = document.createElement('a')
      dom.style.display = 'none'
      dom.href = url
      // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
      dom.setAttribute('download', fileName || '文件')
      document.body.appendChild(dom)
      dom.onclick = function() {
        document.body.removeChild(dom)
      }
      dom.click()
    }
  })
}

/**
 * 设置LocalStorage
 * @param String key
 * @param {Object} val
 */
export function setLocalStorage(key, val) {
  val = val || {}
  try {
    if (localStorage && localStorage.setItem) {
      localStorage.setItem(key, escape(JSON.stringify(val)))
    }
  } catch (oException) {
    if (oException && oException.name === 'QuotaExceededError') {
      console.log('超出本地存储限额！')
      // 如果历史信息不重要了，可清空后再设置
      if (localStorage) {
        localStorage.clear()
        localStorage.setItem(key, escape(JSON.stringify(val)))
      }
    }
  }
}

// 获取localstorege缓存数据
export function getLocalStorage(key) {
  let val = ''
  if (localStorage && localStorage.getItem) {
    val = unescape(localStorage.getItem(key))
  }
  if (!val || val === void 0) return {}
  return JSON.parse(val) || {}
}

// 移除localstorege缓存数据
export function removeLocalStorage(key) {
  if (localStorage && localStorage.removeItem) {
    localStorage.removeItem(key)
  }
}
